"use client";

import AuthErrorModalContainer from "@/app/(discover)/components/auth-error-modal.container";
import { NonCandidateModalContainer } from "@/components/shared/auth-paywall/non-candidate-modal.container";

export default function GlobalModals() {
  return (
    <>
      <AuthErrorModalContainer />
      <NonCandidateModalContainer />
    </>
  );
}
